/**
 * Avatar component for CardV2 facepile.
 */

import React, { FC } from 'react';
import { styled } from 'linaria/react';

import { COLORS, FONTS } from '../../../styles/constants';
import { AvatarProps } from '../types';
import { DIMENSIONS, BORDER_RADIUS } from '../styled/tokens';

const StyledAvatar = styled.div<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: ${BORDER_RADIUS.circle}px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
`;

const StyledImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
`;

const StyledFallback = styled.div<{ size: number }>`
  width: 100%;
  height: 100%;
  background-color: ${COLORS.brown.dark['30']};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${FONTS.secondary};
  font-size: ${({ size }) => size * 0.4}px;
  font-weight: 600;
  color: ${COLORS.white['100']};
  text-transform: uppercase;
`;

const Avatar: FC<AvatarProps> = ({ src, size = DIMENSIONS.avatar, fallbackLetter = '?', className }) => {
  return (
    <StyledAvatar size={size} className={className}>
      {src ? (
        <StyledImage src={src} alt="" loading="lazy" />
      ) : (
        <StyledFallback size={size}>{fallbackLetter.charAt(0)}</StyledFallback>
      )}
    </StyledAvatar>
  );
};

export default Avatar;
